"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _StyleConfig = require("../utils/StyleConfig");
var _AddChildPropsContext = _interopRequireDefault(require("../utils/_AddChildPropsContext"));
var _SceneSimpleBell = _interopRequireDefault(require("./IllustrationTypes/_SceneSimpleBell"));
var _SceneSimpleEmptyList = _interopRequireDefault(require("./IllustrationTypes/_SceneSimpleEmptyList"));
var _SceneSimpleMagnifier = _interopRequireDefault(require("./IllustrationTypes/_SceneSimpleMagnifier"));
var _SceneSimpleNotFoundMagnifier = _interopRequireDefault(require("./IllustrationTypes/_SceneSimpleNotFoundMagnifier"));
var _SceneSimpleTask = _interopRequireDefault(require("./IllustrationTypes/_SceneSimpleTask"));
var _SceneSimpleMail = _interopRequireDefault(require("./IllustrationTypes/_SceneSimpleMail"));
var _SceneSimpleEmptyDoc = _interopRequireDefault(require("./IllustrationTypes/_SceneSimpleEmptyDoc"));
var _SceneSimpleCalendar = _interopRequireDefault(require("./IllustrationTypes/_SceneSimpleCalendar"));
var _SceneSimpleNoSavedItems = _interopRequireDefault(require("./IllustrationTypes/_SceneSimpleNoSavedItems"));
var _SceneSimpleReload = _interopRequireDefault(require("./IllustrationTypes/_SceneSimpleReload"));
var _SceneSimpleError = _interopRequireDefault(require("./IllustrationTypes/_SceneSimpleError"));
var _SceneSimpleConnection = _interopRequireDefault(require("./IllustrationTypes/_SceneSimpleConnection"));
var _SceneSimpleBalloon = _interopRequireDefault(require("./IllustrationTypes/_SceneSimpleBalloon"));
var _SceneSimpleCheckmark = _interopRequireDefault(require("./IllustrationTypes/_SceneSimpleCheckmark"));
var _DialogIllustratedFaceID = _interopRequireDefault(require("./IllustrationTypes/_DialogIllustratedFaceID"));
var _excluded = ["ariaHidden", "type"];
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
/** **Illustration**s are design recommendations for empty states. They include an illustration
 * paired with a message that, together, communicate what the user would see if they had data,
 * while providing constructive guidance about next steps.
 * They serve to add clarity and to humanize the experience users have with SAP products.
 *
 * Use with
 * [**IllustrationMessage**](./?path=/docs/components-alerts-messaging-illustratedmessage--docs)
 * to provide a complete message.
 *
 * To request additional illustrations, contact \#ask-core-ui. */

var Illustration = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var addChildProps = (0, _react.useContext)(_AddChildPropsContext.default);
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(Illustration, _props)) : _props;
  var ariaHidden = props.ariaHidden,
    type = props.type,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var illustrations = {
    SceneSimpleEmptyList: _SceneSimpleEmptyList.default,
    SceneSimpleMagnifier: _SceneSimpleMagnifier.default,
    SceneSimpleNotFoundMagnifier: _SceneSimpleNotFoundMagnifier.default,
    SceneSimpleTask: _SceneSimpleTask.default,
    SceneSimpleBell: _SceneSimpleBell.default,
    SceneSimpleMail: _SceneSimpleMail.default,
    SceneSimpleEmptyDoc: _SceneSimpleEmptyDoc.default,
    SceneSimpleCalendar: _SceneSimpleCalendar.default,
    SceneSimpleNoSavedItems: _SceneSimpleNoSavedItems.default,
    SceneSimpleReload: _SceneSimpleReload.default,
    SceneSimpleError: _SceneSimpleError.default,
    SceneSimpleConnection: _SceneSimpleConnection.default,
    SceneSimpleBalloon: _SceneSimpleBalloon.default,
    SceneSimpleCheckmark: _SceneSimpleCheckmark.default,
    DialogIllustratedFaceID: _DialogIllustratedFaceID.default
  };
  var Component = illustrations[type];
  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, otherProps, {
    "aria-hidden": ariaHidden,
    ref: ref
  }));
});
Illustration.displayName = 'Illustration';
Illustration.propTypes = {
  /** Type of illustration to render. */
  type: _propTypes.default.oneOf(_StyleConfig.ILLUSTRATION_TYPES).isRequired,
  /** The value for the `aria-hidden` attribute. Set to `true` when there
   * is already visible text explaining the **Illustration** or when
   * the **Illustration** is purely for decoration.
   *
   * Note: if using **Illustration** as part of an **IllustratedMessage**, the
   * parent component will set this prop. */
  ariaHidden: _propTypes.default.bool,
  /** Accessible title describing image. This is only required when using
   * **Illustration** when `ariaHidden` is false.
   */
  title: _propTypes.default.string,
  /** Custom classname to add to the `svg` element. */
  className: _propTypes.default.string
};
var _default = Illustration;
exports.default = _default;